(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hydroone-simple-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', function(event) {
  if (!event.target.matches('.ho-footer-menu') || !event.target.open) return;
  requestAnimationFrame(function() {
    window.scrollTo({top: document.documentElement.scrollHeight, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
}, true);

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.ho-footer-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});

  } catch(e) { console.error(e); }
})();
})();
